import { HttpErrorResponse, HttpStatusCode } from '@angular/common/http';

/** Whether an error is the backend's "authenticated but not authorized" (403) response. */
export function isAuthForbidden(error: unknown): boolean {
  return error instanceof HttpErrorResponse && error.status === HttpStatusCode.Forbidden;
}
